const breakpoints = {
  xsmall: "20em",
  //320px
  small: "40em",
  //640px
  medium: "50.875em",
  //814px
  large: "66.625em",
  //1066px
  xlarge: "87.5em",
  //1400px
  xxlarge: "100em" //1600px

};
const cmpBreakpoints = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px"
};

const acurisBlack = '#232121';
const white = '#fff';
const acurisGlobal = {
  lightest: '#fff5f6',
  lighter: '#ffe6e8',
  light: '#f7d0db',
  medium: '#d84a57',
  dark: '#bc3f4e',
  darker: '#8e334d',
  darkest: '#33141d'
};
const compliance = {
  lightest: '#fcf9f5',
  lighter: '#faf3ec',
  light: '#f6e7d9',
  medium: '#d38b44',
  dark: '#b15f22',
  darker: '#99531f',
  darkest: '#80461b'
};
const equities = {
  lightest: '#f9fcf7',
  lighter: '#f1f7ee',
  light: '#e3efde',
  medium: '#77af5a',
  dark: '#458535',
  darker: '#3b7433',
  darkest: '#306230'
};
const fixedIncome = {
  lightest: '#f7f9fc',
  lighter: '#e6edf9',
  light: '#ccdbf3',
  medium: '#004fc4',
  dark: '#0458b8',
  darker: '#0348a1',
  darkest: '#013789'
};
const infrastructure = {
  lightest: '#f8fcfb',
  lighter: '#f1f8f7',
  light: '#e4f1ef',
  medium: '#4aa092',
  dark: '#1f8e7c',
  darker: '#1d7769',
  darkest: '#1a6559'
};
const services = {
  lightest: '#fcf7fc',
  lighter: '#f5ecf5',
  light: '#ebd8ec',
  medium: '#9b3fa0',
  dark: '#833587',
  darker: '#6a306e',
  darkest: '#512a55'
};
const transactionsTurquoise = {
  lightest: '#f7fcfc',
  lighter: '#edf5f4',
  light: '#daece9',
  medium: '#4aa092',
  dark: '#1d8574',
  darker: '#1b7163',
  darkest: '#185c52'
};
const transactions = {
  lightest: '#f7fbfc',
  lighter: '#ecf4f7',
  light: '#d9e9ef',
  medium: '#4293b2',
  dark: '#397e99',
  darker: '#326987',
  darkest: '#2f5d80'
};
const divisionColorsMap = {
  fixedIncome,
  equities,
  compliance,
  infrastructure,
  services,
  transactions,
  transactionsTurquoise,
  acurisGlobal
}; // @ts-ignore

const themeable = key => ({
  theme
}) => {
  const colorScheme = theme.divisionColourScheme; // @ts-ignore

  if (!colorScheme) return acurisGlobal[key]; // @ts-ignore

  return divisionColorsMap[colorScheme][key];
};

const divisionColors = {
  lightest: themeable('lightest'),
  lighter: themeable('lighter'),
  light: themeable('light'),
  medium: themeable('medium'),
  dark: themeable('dark'),
  darker: themeable('darker'),
  darkest: themeable('darkest')
};
const acurisGlobalColors = acurisGlobal;
const warmGrey = {
  I: '#f5f2f0',
  II: '#f0ece9',
  III: '#eae5e1',
  IV: '#e1dbd5',
  V: '#d6d0c8',
  VI: '#bbb4ac',
  VII: '#96908a',
  VIII: '#706c67',
  IX: '#5d5955',
  X: '#4a4844',
  XI: '#373533'
};
const colors = {
  primaryBackground: white,
  primaryBrand: divisionColors.darker,
  primaryBrandHover: divisionColors.dark,
  primaryFont: acurisBlack,
  primaryFontInverse: white,
  primaryFontInverseDisabled: warmGrey.VII,
  disabled: warmGrey.VI,
  outline: '#f6ca66'
};
const universal = {
  green: {
    dark: '#208522',
    darker: '#175e18'
  },
  amber: {
    dark: '#cc4e00',
    darker: '#9b3e05'
  },
  red: {
    dark: '#bd2d2d',
    darker: '#8f1717'
  }
};
const notificationColors = {
  success: universal.green.dark,
  successDarker: universal.green.darker,
  warning: universal.amber.dark,
  warningDarker: universal.amber.darker,
  failure: universal.red.dark,
  failureDarker: universal.red.darker
};
const cmpBootstrapGrays = {
  gray100: '#f8f9fa',
  gray200: '#e9ecef',
  gray300: '#dee2e6',
  gray400: '#ced4da',
  gray500: '#adb5bd',
  gray600: '#6c757d',
  gray700: '#495057',
  gray800: '#343a40',
  gray900: '#212529'
};
const hexColourToRgb = hex => {
  // size variable to assess if the hex code chunks should be 2 or 1 character long (for shorthand hex notation, like `#A0C` for `#AA00CC`)
  const size = hex.replace('#', '').length === 3 ? 1 : 2; // conversion directly into string in decimal/RGB format

  return Array.from({
    length: 3
  }, (_, i) => parseInt(hex.slice((-3 + i) * size, (-2 + i) * size || hex.length).repeat(2 / size), 16)).join(',');
};

const fontFamily = {
  primary: "Lato,HelveticaNeue,helvetica,arial,sans-serif;",
  secondary: "Lora,georgia,serif;"
};
const fontWeight = {
  normal: 400,
  bold: 700
};

const pixelToRem = pixel => `${pixel / 10}rem`;

const guttersPx = {
  xsmall: 6,
  small: 6,
  medium: 6,
  large: 8,
  xlarge: 8,
  xxlarge: 12
};
const gutters = Object.keys(guttersPx).reduce((acc, key) => ({ ...acc,
  // @ts-ignore
  [key]: pixelToRem(guttersPx[key])
}), {});
const doubleGutters = Object.keys(guttersPx).reduce((acc, key) => ({ ...acc,
  // @ts-ignore
  [key]: pixelToRem(guttersPx[key] * 2)
}), {});

const gridWidth = (columnsOccupied, totalColumns) => `${(100 * (columnsOccupied / totalColumns)).toFixed(4)}%`;

var grid = {
  gutters,
  doubleGutters,
  gridWidth
};

const themes = {
  fixedIncome: {
    divisionColourScheme: "fixedIncome"
  },
  equities: {
    divisionColourScheme: "equities"
  },
  compliance: {
    divisionColourScheme: "compliance"
  },
  infrastructure: {
    divisionColourScheme: "infrastructure"
  },
  services: {
    divisionColourScheme: "services"
  },
  transactions: {
    divisionColourScheme: "transactions"
  },
  transactionsTurquoise: {
    divisionColourScheme: "transactionsTurquoise"
  },
  acurisGlobal: {
    divisionColourScheme: "acurisGlobal"
  }
};

export { acurisGlobalColors, breakpoints, cmpBootstrapGrays, cmpBreakpoints, colors, divisionColors, fontFamily, fontWeight, grid, hexColourToRgb, notificationColors, themes, warmGrey };
//# sourceMappingURL=index.js.map
